import { render, staticRenderFns } from "./goldenSentenceDilets.vue?vue&type=template&id=b7021566&scoped=true&"
import script from "./goldenSentenceDilets.vue?vue&type=script&lang=js&"
export * from "./goldenSentenceDilets.vue?vue&type=script&lang=js&"
import style0 from "./goldenSentenceDilets.vue?vue&type=style&index=0&id=b7021566&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b7021566",
  null
  
)

export default component.exports